import { IconButton, Stack, SvgIcon, Tooltip, Typography } from "@mui/material";
import { ChangeEvent, FC, RefObject, useMemo } from "react";
import ClearIcon from '@mui/icons-material/Clear';
import { getStyles } from "./styles";
import { useTranslation } from "react-i18next";
import "./styles.css";
import { tokens } from "../../../../../../locales/tokens";

interface IProps {
    imageSrc: string;
    isValid: boolean;
    handleFileChange: (event: ChangeEvent<HTMLInputElement>) => void;
    handleClearImageClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

export const ImagePicker: FC<IProps> = ({ imageSrc, handleFileChange, isValid, handleClearImageClick }) => {
    const { t } = useTranslation();
    const styles = useMemo(() => getStyles(), []);

    return (
        <>
            <Typography variant="h6" color={isValid ? 'inherit' : 'error'}>{t(tokens.adverts.cover)}*</Typography>
            <Stack mt={1} position="relative">
                <label htmlFor="fileInput" className="image">
                    <img
                        src={imageSrc || "/images/user/uploadImage.png"}
                        alt="uploadImage"
                        width={112}
                        height={112}
                        className="image"
                    />
                    {imageSrc ?
                        <IconButton sx={styles.clearImage} onClick={handleClearImageClick}>
                            <Tooltip title={t(tokens.common.edit)} placement="right">
                                <SvgIcon><ClearIcon /></SvgIcon>
                            </Tooltip>
                        </IconButton>
                        : null
                    }
                </label>
                <input
                    type="file"
                    id="fileInput"
                    accept="image/*"
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                />
            </Stack>
        </>
    )
};